import React from 'react';
import { getItem, clear } from '../../utils/localStorage';
import { ButtonLarge } from './../../app/common/sharedComponents/buttons/ButtonLarge';
import { useNavigate } from 'react-router-dom';
import { disablePushNotifications } from '../../utils/OneSignalInitializer';
import { AppHeader } from '../../app/common/sharedComponents/AppHeader';
import { useTranslation } from 'react-i18next';
import {
  Wrapper,
  ProfileContainer,
  HeaderSection,
  TitleProfile,
  ProfileForm,
  ProfileTopSection,
  ProfileBottomSection,
  FieldRow,
  FieldRowLabel,
  FieldRowText,
} from './styled.login';

const Profile = () => {
  const userData = getItem('user');
  const userInfo = userData.user;
  const navigate = useNavigate();
  const { t } = useTranslation();

  const signOutClickHandler = async () => {
    await disablePushNotifications();
    clear();
    // navigate('/login');
    window.location.href = '/login';
    navigate(0);
  };

  return (
    <Wrapper>
      <AppHeader title={t('COMMON.PROFILE.TITLE')} hasBackButton={true} />
      <ProfileContainer>
        <ProfileTopSection>
          <HeaderSection>
            <TitleProfile>User Information</TitleProfile>
          </HeaderSection>
          <ProfileForm>
            <FieldRow>
              <FieldRowLabel>Email</FieldRowLabel>
              <FieldRowText>{userInfo.userEmail}</FieldRowText>
            </FieldRow>
            <FieldRow>
              <FieldRowLabel>Role</FieldRowLabel>
              <FieldRowText>{userInfo.userRole}</FieldRowText>
            </FieldRow>
            <FieldRow>
              <FieldRowLabel>First Name</FieldRowLabel>
              <FieldRowText>{userInfo.userFirstName}</FieldRowText>
            </FieldRow>
            <FieldRow>
              <FieldRowLabel>Last Name</FieldRowLabel>
              <FieldRowText>{userInfo.userLastName}</FieldRowText>
            </FieldRow>
          </ProfileForm>
        </ProfileTopSection>
        <ProfileBottomSection>
          <ButtonLarge
            title={t('COMMON.OUTSIDE.BUTTONS.SIGN_OUT')}
            onClick={() => {
              signOutClickHandler();
            }}
            outlined={true}
            inverted={true}
          />
        </ProfileBottomSection>
      </ProfileContainer>
    </Wrapper>
  );
};

export default Profile;
